import { render, staticRenderFns } from "./bomNew.vue?vue&type=template&id=15d5154d&scoped=true&"
import script from "./bomNew.vue?vue&type=script&lang=js&"
export * from "./bomNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15d5154d",
  null
  
)

export default component.exports